import {createContext} from 'react'
import {ModalPolicyUpdateHandler} from 'types'

export const ModalPolicyUpdateContext = createContext<
  ModalPolicyUpdateHandler | undefined
>(undefined)
